var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"hiSubnav"}},[_c('div',{staticClass:"row q-mx-auto justify-between items-center"},[_c('div',{staticClass:"col q-pb-md q-pt-lg"},_vm._l((_vm.childs),function(c,i){return _c('router-link',{key:i,staticClass:"subnavlink left",attrs:{"to":c.url}},[_vm._v(_vm._s(c.label))])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }